import React, { useState, useEffect } from "react";
import MeetupImage1 from "../../../assets/images/MeetupImages/unsplash_MXbM1NrRqtI.png";
import RadisonBlue from "../../../assets/images/MeetupImages/unsplash_QdAAasrZhdk.png";
import LeMerridian from "../../../assets/images/MeetupImages/unsplash_xEaAoizNFV8.png";
import Session from "../../../assets/images/MeetupImages/unsplash_YC8qqp50BdA.png";
import EnterImage from "../../../assets/images/enter 1.png";
import DefaultBanner from "../../../assets/images/Auditions/default.jpg";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import { Markup } from "interweave";
import { serverInfo } from "../../../App";
import { useContext } from "react";

const PendingAuditionSlider = (props) => {
  const { imageCdnUrl } = useContext(serverInfo);

  let history = useHistory();

  const [pendings, setPendings] = useState([]);

  useEffect(() => {
    axios.get("/api/audition-admin/audition/pendings").then((res) => {
      if (res.data.status === 200) {
        setPendings(res.data.pendings);
      }
    });
  }, []);


  return (
    <div>
      <div>
        <div className="slick-parent d-flex justify-content-center">
         
            {pendings.map((pending, index) => (
              <Link
                to={`/audition-admin/audition/pending/${pending.id}`}
                className="Link"
              >
                <div className="p-3" style={{ cursor: "pointer" }}>
                  <div className="completedMeetupBlack">
                    <img
                      src={
                        pending.banner == null
                          ? DefaultBanner
                          : imageCdnUrl+pending.banner
                      }
                      className="img-fluid w-100"
                      alt=""
                      style={{
                        height: "200px",
                        width: "300px",
                      }}
                    />
                    <div className="p-3">
                      <div className="d-flex justify-content-between">
                        <h5 className="text-white">{pending.title}</h5>
                        <img className="img-fluid" src={EnterImage} alt="" />
                      </div>

                      <p className="text-secondary">
                        <Markup content={pending.description}></Markup>
                      </p>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
     
        </div>
      </div>
    </div>
  );
};

export default PendingAuditionSlider;
